import { isEqual } from "lodash";

import { useMemo } from "react";

import { getOptionCheckedText } from "@/utils/filter";

import { useFilterContext } from "../FilterContext";
import { getFilterConfigByKey } from "../filters";
import { FilterData } from "../typing";

/**
 * 用于回显选中的filterButton
 * @returns
 */
const useFilterChecked = () => {
  const { filterData, filterOptions, defaultFilterData } = useFilterContext();
  return useMemo(() => {
    const filterCheckedMap: Record<string, string> = {};

    const isDefault = (key: keyof FilterData) => {
      return isEqual(defaultFilterData[key], filterData[key]);
    };

    const filterOptionsMap = {
      brand: filterOptions.brandOptions,
      banks: filterOptions.banksOptions,
      subBrand: filterOptions.subBrandOptions,
      certificates: filterOptions.certificates,
    };

    for (const key of Object.keys(filterData)) {
      switch (key) {
        case "brand":
        case "subBrand":
        case "certificates":
        case "banks": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : getOptionCheckedText(filterOptionsMap[key], filterData[key]);
          break;
        }
        case "pointsPrice": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : `${key}: ${Math.ceil(filterData[key] / 1000)}K`;
          break;
        }
        case "distance": {
          filterCheckedMap[key] = isDefault(key) ? "" : `${key}: ${filterData[key]}miles`;
          break;
        }
        case "cashRate":
        case "gRating": {
          filterCheckedMap[key] = isDefault(key)
            ? ""
            : `${getFilterConfigByKey(key)?.label}: ${filterData[key]}`;
          break;
        }

        default:
          break;
      }
    }

    return filterCheckedMap;
  }, [filterData, filterOptions, defaultFilterData]);
};

export default useFilterChecked;
